import React, { Component } from "react";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import NativeSelect from '@material-ui/core/NativeSelect';
import { makeStyles, withStyles } from '@material-ui/core/styles';

class AppConfigList extends Component {
	

	constructor(props) {
        super(props);
		
		this.handleConfigChange=this.handleConfigChange.bind(this);
    }
	
	handleConfigChange(configKey, e) {
		e.preventDefault();
		const {name, value} = e.target;
		this.props.handleConfigChange(configKey, value);
	}

	render() {
		const rows = [];
		this.props.appConfigRecords.forEach(config => rows.push(<tr>
																	<td>{config.key}</td>
																	<td><NativeSelect name="selectValue" value={config.value} onChange={(e) => { this.handleConfigChange(config.key, e); }}><option value="TRUE">TRUE</option><option value="FALSE">FALSE</option></NativeSelect></td>
																</tr>));
		return (
		<div className="content">
		  <Table className="lst">
		    <TableHead>
		      <TableRow>
				<TableCell>Key</TableCell>
				<TableCell>Value</TableCell>
		      </TableRow>
		    </TableHead>
		    <TableBody>{rows}</TableBody>
		  </Table>
		</div>
		);
  }
};

export default AppConfigList;